import styled from "styled-components";
import { BodyDefault } from "../../../../../components/typography/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  padding: 0px 30px 50px 30px;
  gap:20px;

  @media screen and (max-width: 900px) {
    padding: 0 16px 32px;
  }
`

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap:20px;
  min-width: 0;
  max-width: 100%;
`

export const TextBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap:20px;
  min-width: 0;

  @media screen and (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }
`

export const InfoText = styled(BodyDefault)`
  color:${({theme}) => theme.grey[700]};
`

export const JsonEditorScrollport = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`
